import { useEffect, useMemo, useState } from 'react'

interface Props {
  initialTime: number
  onTimeout?: () => void
  className?: string
}

const Countdown = ({
  initialTime,
  onTimeout = console.log,
  className
}: Props) => {
  const [seconds, setSeconds] = useState(initialTime)

  useEffect(() => {
    if (seconds === 0) {
      onTimeout?.()
    } else {
      const timerInterval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1)
      }, 1000)

      return () => clearInterval(timerInterval)
    }
  }, [onTimeout, seconds])

  const formattedtime = useMemo(() => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }, [seconds])

  return <span className={className}>{formattedtime}</span>
}

export default Countdown
